
import { Card } from "@/components/ui/card";
import { HelpCircle } from "lucide-react";
import GlassCard from "@/components/ui/glass-card";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { ReactNode } from "react";

type DashboardStatProps = {
  title: string;
  value: string | ReactNode;
  subtitle: string;
  tooltip?: string;
};

const DashboardStat = ({ title, value, subtitle, tooltip }: DashboardStatProps) => (
  <GlassCard 
    className="p-6" 
    hover={false} 
    variant="subtle"
  >
    <div className="flex flex-col">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm text-muted-foreground font-medium flex items-center">
          {title}
          {tooltip && (
            <Dialog>
              <DialogTrigger className="cursor-help inline-flex ml-1">
                <HelpCircle className="h-3.5 w-3.5 text-muted-foreground/70" />
              </DialogTrigger>
              <DialogContent className="max-w-md">
                <DialogHeader>
                  <DialogTitle>{title}</DialogTitle>
                  <DialogDescription>
                    {tooltip}
                  </DialogDescription>
                </DialogHeader>
              </DialogContent>
            </Dialog>
          )}
        </h3>
      </div>
      <div>
        <div className="text-3xl font-bold">{value}</div>
        <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
      </div>
    </div>
  </GlassCard>
);

export default DashboardStat;
